import { makeSceneDoc } from '../kit.js';

/**
 * 出村的土路：贯穿南北的黄土道，两侧农田与树。
 * 往北回家，往西进邻居院子，往东下河滩，往南就是那五千七百步。
 */
export const countryRoadDoc = makeSceneDoc({
  id: 'country_road',
  name: '出村的土路',
  region: 'suburb',
  tier: 0,
  node: 'country_road',
  desc: '一脚踩下去扬尘三尺，走一趟浑身是土。',
  w: 40, h: 26,
  fill: ',',
  spawn: { gx: 20, gy: 2 },
  draw(b, rng) {
    b.rect(14, 0, 12, 26, 'r');                    // 南北向土路
    b.rect(0, 0, 14, 26, ',');
    b.rect(26, 0, 14, 26, ',');
    b.rect(0, 0, 40, 2, ',');
    // 两侧农田与地块
    b.rect(1, 3, 11, 8, 'f');
    b.rect(28, 6, 11, 9, 'f');
    b.rect(1, 14, 10, 7, ':');
    b.rect(29, 18, 10, 6, 'f');
    // 树下、草丛
    b.scatter(',', 24, { rng, area: [1, 3, 12, 20] });
    b.scatter(',', 24, { rng, area: [27, 3, 12, 20] });
    // 车辙
    b.hline(16, 16, 12, ':');
    b.hline(22, 22, 18, ':');
  },
  props: [
    { type: 'milestone', gx: 13, gy: 8 },
    { type: 'road_sign', gx: 26, gy: 4 },
    { type: 'broken_cart', gx: 17, gy: 14 },
    { type: 'junk_pile', gx: 22, gy: 20 },
    { type: 'riceball_stall', gx: 15, gy: 4 },
    { type: 'tree', gx: 8, gy: 12 },
    { type: 'tree', gx: 31, gy: 15 },
    { type: 'flat_fruit_vendor', gx: 27, gy: 11 },
  ],
  portals: [
    { to: 'carport', gx: 20, gy: 1, spawn: [20, 21], label: '回家' },
    { to: 'neighbor_yard', gx: 1, gy: 13, spawn: [24, 12], label: '邻家院子' },
    { to: 'riverside', gx: 38, gy: 13, spawn: [3, 10], label: '河边滩地' },
    { to: 'highway', gx: 20, gy: 24, spawn: [22, 2], label: '往城去' },
  ],
});

export default countryRoadDoc;
